import { useEffect, useState } from 'react';
import { SpecialGate } from '../../components/SpecialGate';
import { managerApi } from '../../lib/api';

const ACAO_LABEL: Record<string, string> = {
  'acessar-area-restrita': 'Acesso à área restrita',
  'exportar-backup': 'Exportação de backup',
  'excluir-funcionarios': 'Exclusão de funcionários',
  'gerenciar-senha-mestre': 'Gerenciar senha mestre',
  'trocar-tipo-horario': 'Troca de tipo de horário',
  'funcionario-alterou-pin': 'Funcionário trocou a própria senha',
};

function AuditLogList({ senha }: { senha: string }) {
  const [logs, setLogs] = useState<any[] | null>(null);

  useEffect(() => {
    managerApi.listAuditLog(senha).then((res) => setLogs(res.logs));
  }, [senha]);

  if (logs === null) return <div className="card"><p className="muted">Carregando…</p></div>;

  return (
    <div className="card">
      <h2>Auditoria de ações sensíveis</h2>
      <p className="hint">
        Registro de quem acessou a área restrita, exportou backup, excluiu funcionários, mexeu nas senhas mestres
        ou trocou o tipo de horário — inclusive tentativas com senha errada. Só quem tem a senha especial vê isso,
        mesmo que outras pessoas tenham senha mestre.
      </p>
      <div className="table-wrap" style={{ marginTop: 14 }}>
        <table>
          <thead><tr><th>Data/hora</th><th>Ação</th><th>Detalhe</th><th>Status</th></tr></thead>
          <tbody>
            {logs.length === 0 && <tr><td colSpan={4} className="muted">Nenhum registro ainda.</td></tr>}
            {logs.map((l, i) => (
              <tr key={i}>
                <td className="mono">{new Date(l.criadoEm).toLocaleString('pt-BR')}</td>
                <td>{ACAO_LABEL[l.acao] || l.acao}</td>
                <td>{l.detalhe || '—'}</td>
                <td>{l.sucesso ? <span className="pill pill-ok">ok</span> : <span className="pill pill-warn">senha errada</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function AuditoriaTab() {
  return (
    <SpecialGate>
      {(senha) => <AuditLogList senha={senha} />}
    </SpecialGate>
  );
}
